module.exports = __webpack_public_path__ + "media/min-min.f763dc90.wav";